'use strict';

let moduleName = 'jquery-bar-rating';

require('jquery-bar-rating');

module.exports = function () {
	$('[js-jquery-bar-rating]').each(function () {
		if ($.data(this, moduleName + '-init')) return;
		$.data(this, moduleName + '-init', true);



		let $wrap = $(this);



		$wrap.barrating();



	});
};


/** WEBPACK FOOTER **
 ** D:/phpstorm/szar/src/js/modules/jqueryBarRatingInit.js
 **/